module.exports = __webpack_public_path__ + "static/media/Quote 3 - Mobile.d606f158.png";